import { Switch, SwitchProps } from '@mui/material'
import React from 'react'

function ToggleSwitchWithRef(props: SwitchProps, ref: any) {
    const { checked } = props
    return (
        <Switch
            {...props}
            ref={ref}
            sx={{
                '&.Mui-disabled': {
                    color: checked ? 'primary.main' : '#bdbdbd',
                    opacity: checked ? 0.7 : 'unset',
                },
                '&.Mui-disabled+.MuiSwitch-track': {
                    backgroundColor: checked ? 'primary.main' : '#000',
                },
            }}
        />
    )
}

const ToggleSwitch = React.forwardRef(ToggleSwitchWithRef)
export default ToggleSwitch
